import React from 'react';

export default function IconHamburger({fill = '#d8d8d8'}) {
    return (
        <svg width="14" height="14" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.0028 2.39746H1.39565C1.14908 2.39746 0.949219 2.20072 0.949219 1.95801V0.859375C0.949219 0.61666 1.14908 0.419922 1.39565 0.419922H13.0028C13.2494 0.419922 13.4492 0.61666 13.4492 0.859375V1.95801C13.4492 2.20072 13.2494 2.39746 13.0028 2.39746ZM13.0028 6.79199H1.39565C1.14908 6.79199 0.949219 6.59525 0.949219 6.35254V5.25391C0.949219 5.01119 1.14908 4.81445 1.39565 4.81445H13.0028C13.2494 4.81445 13.4492 5.01119 13.4492 5.25391V6.35254C13.4492 6.59525 13.2494 6.79199 13.0028 6.79199ZM13.0028 11.1865H1.39565C1.14908 11.1865 0.949219 10.9898 0.949219 10.7471V9.64844C0.949219 9.40572 1.14908 9.20898 1.39565 9.20898H13.0028C13.2494 9.20898 13.4492 9.40572 13.4492 9.64844V10.7471C13.4492 10.9898 13.2494 11.1865 13.0028 11.1865Z" fill="#546878"/>
        </svg>
        
    );
}



// WEBPACK FOOTER //
// ./components/icon_hamburger/index.js